import { reactive, toRefs, watch, ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { Close } from '@element-plus/icons-vue';
import BN from 'bignumber.js';
import { loanApi } from '@/apis/spot';
import { toFormat, times, gt } from '@/utils/number';
import { formatLocalTime } from '@/utils/time';
import { toVipProgram } from '@/utils/jumplink';
import { accounts } from '@/config/loan';
import SfeInput from '@/components/Input';
import { sensorsClick } from '@/utils/sensors';
import TokenSelect from '../loan/Select';
import { errorToast } from '../../hooks/useToast';
import { usePrecision } from '../../hooks/usePrecision';
import VipSuccess from './VipSuccess';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    token: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      required: true
    }
  },
  emits: ['update:visible', 'success'],
  components: {
    Close,
    // KycDialog,
    SfeInput,
    TokenSelect,
    VipSuccess
  },
  setup(props, {
    emit
  }) {
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const store = useStore();
    const userInfo = computed(() => store.state.loan.user);
    const isVIP = computed(() => store.getters['user/isVIP']);
    const isSub = computed(() => store.getters['user/isSub']);
    const state = reactive({
      // minAccount: 0,
      loading: false,
      time: Date.now(),
      loanToken: props.token,
      currentSocial: null,
      amount: null,
      amountErrorTip: null,
      snsNameErrorTip: null,
      accountErrorTip: null,
      socialName: '',
      accountId: null,
      socialMediaList: [
      // 10:Telegram, 20:WhatsApp, 30:X.com, 40:Email, 99:Other
      {
        id: 10,
        label: 'Telegram'
      }, {
        id: 20,
        label: 'WhatsApp'
      }, {
        id: 30,
        label: 'X.com'
      }, {
        id: 50,
        label: 'Kakao'
      }, {
        id: 60,
        label: 'Line'
      }, {
        id: 70,
        label: 'Mobile Number'
      }, {
        id: 40,
        label: 'Email'
      }, {
        id: 99,
        label: 'Other'
      }],
      successModal: false,
      maxLoanQuota: null,
      minLoanQuota: null
    });

    // 用户校验
    const checkData = ref({
      visible: false,
      content: '',
      code: 0,
      confirmText: ''
    });
    const getData = async () => {
      try {
        const res = await loanApi.getVipLoanApply();
        const {
          result,
          code
        } = res || {};
        if (code === 0 && result?.[0]) {
          const data = result?.[0];
          state.currentSocial = data?.snsType;
          state.accountId = data?.snsAccount;
          if (data?.snsType === 99) {
            state.socialName = data?.snsName;
          }
        }
      } catch (e) {
        console.error(e);
      }
    };
    const getLoanRange = async token => {
      state.maxLoanQuota = null;
      state.minLoanQuota = null;
      try {
        const res = await loanApi.getVipLoanRange({
          token
        });
        const {
          result,
          code
        } = res || {};
        if (code === 0) {
          state.maxLoanQuota = new BN(result.maxLoanQuota).integerValue(BN.ROUND_DOWN);
          state.minLoanQuota = new BN(result.minLoanQuota).integerValue(BN.ROUND_CEIL);
        }
      } catch (e) {
        console.error(e);
      }
    };
    watch(() => props.visible, visible => {
      console.log('vip visible:', visible);
      if (visible) {
        getData();
      }
    });

    // watch([() => props.data, () => props.token], ([list, lt]) => {
    //     state.minAccount = times(Number((list?.filter((key) => key.token === lt))?.[0]?.maxUserLoanQuota), 1.1);
    // }, { immediate: true });

    watch([() => props.visible, () => state.loanToken], ([visible, token]) => {
      if (visible) {
        getLoanRange(token || props.token);
      }
    }, {
      immediate: true
    });

    // const maxNum = '999999999999999999';

    const methods = {
      // 修改借贷币种
      changeLoanToken(token) {
        state.loanToken = token;
        state.amount = null;
        state.amountErrorTip = null;
        // state.minAccount = times(Number((props.data.filter((key) => key.token === token))?.[0]?.maxUserLoanQuota), 1.1);
        // getLoanRange(token);
      },

      changeSuccessModal(newState) {
        state.successModal = newState;
      },
      handleAmountInput() {
        if (state.amount == null) {
          state.amountErrorTip = t('variableCannotBeEmpty', {
            variable: t('loanAmount')
          });
        } else {
          state.amountErrorTip = null;
          // if (gt(state.amount, maxNum)) {
          //     state.amount = maxNum;
          // }
        }
      },

      handleSnsTypeChange() {
        if (!state.currentSocial) {
          state.snsNameErrorTip = 'snsNameErrorTip';
        } else {
          state.snsNameErrorTip = null;
        }
      },
      handleSnsNameInput() {
        if (state.socialName == null && state.currentSocial === 99 || !state.currentSocial) {
          state.snsNameErrorTip = 'snsNameErrorTip';
        } else {
          state.snsNameErrorTip = null;
        }
      },
      handleAccountIdInput() {
        if (state.accountId == null) {
          state.accountErrorTip = t('variableCannotBeEmpty', {
            variable: 'ID'
          });
        } else {
          state.accountErrorTip = null;
        }
      },
      // 关闭借款订单弹层
      handleDialogCancel() {
        if (!state.loading) {
          emit('close', false);
        }
        methods.resetData();
      },
      resetData() {
        state.amount = null;
        state.socialName = '';
        state.accountId = null;
        state.amountErrorTip = null;
        state.snsNameErrorTip = null;
        state.accountErrorTip = null;
      },
      verifiedContent() {
        const isEmpty = !state.accountId || !state.amount || !state.socialName && state.currentSocial === 99;
        // Email 校验正则
        const pattern = /^(?=.*[a-zA-Z0-9])\w+@[a-zA-Z0-9]+\.[a-zA-Z0-9]+$/;
        if (!state.accountId) {
          state.accountErrorTip = t('variableCannotBeEmpty', {
            variable: 'ID'
          });
        }
        if (!state.amount) {
          state.amountErrorTip = t('variableCannotBeEmpty', {
            variable: t('loanAmount')
          });
        }
        if (gt(state.minLoanQuota, state.amount)) {
          // 申请数量需超过最小可申请数量
          state.amountErrorTip = t('LoanMinAmountTips');
        }
        if (state.currentSocial == null) {
          state.snsNameErrorTip = 'snsNameErrorTip';
        }
        if (state.currentSocial === 40 && !pattern.test(state.accountId)) {
          state.accountErrorTip = t('LoanEmailTips');
        }
        if (!state.socialName && state.currentSocial === 99) {
          state.snsNameErrorTip = 'snsNameErrorTip';
        }
        if (isEmpty) {
          return 'empty';
        }
        return state.amountErrorTip || state.snsNameErrorTip || state.accountErrorTip;
      },
      // 确认借款
      async handleDialogConfirm() {
        const content = methods.verifiedContent();
        if (content) {
          return;
        }
        try {
          // 调取借款申请接口 执行loading
          const res = await loanApi.postVipLoanApply({
            loanToken: state.loanToken || props.token,
            // 借款币种
            loanQty: state.amount,
            // 借款数量
            snsType: state.currentSocial,
            // 社交账号类型
            snsName: state.socialName,
            // 社交账号名字
            snsAccount: state.accountId,
            // 账号 id
            serialNo: String(Date.now()) // 唯一id
          });
          // eslint-disable-next-line camelcase
          const {
            code,
            ret_code,
            ret_msg
          } = res || {};
          if (code === 0) {
            // success modal
            methods.changeSuccessModal(true);
            emit('update:visible', false);
            store.commit('SET_USER_INFO', {
              ...userInfo,
              appliedVipQuota: true
            });
            methods.resetData();
            return;
          }
          const codes = [100701, 100700, 100702, 100703, 100704, 100705, 100707, 100708, 100709];
          const errMsg = {
            100700: t('submitApplicationLimit'),
            100701: t('receivedApplication'),
            100702: 'application repeated',
            100703: t('LoanMinAmountTips'),
            100704: t('onlyVipCanApply'),
            100705: t('useMainUidToApply'),
            100707: t('pendingOrderReapply'),
            100708: t('sameLimitDontRepeat'),
            100709: t('limitGreaterNoNeedRequest')
          };
          if (codes.includes(code)) {
            errorToast(errMsg[code]);
            emit('update:visible', false);
            methods.resetData();
            return;
          }
          errorToast(ret_msg || t('currentOperationFailed'));
        } catch (e) {
          console.error(e);
        }
      },
      // 快速设置最大申请额度
      setMaxLoanQuota() {
        state.amount = String(state.maxLoanQuota || 0);
        sensorsClick({
          button_name: 'vip_set_max_loan_quota'
        });
      },
      handleAmountBlur() {
        if (gt(state.amount, state.maxLoanQuota || 0)) {
          methods.setMaxLoanQuota();
        }
      },
      handleClickMyLimit() {
        emit('close', false);
        store.commit('loan/SET_TAB', 'Vip');
        store.commit('loan/SET_VIP_TAB', 'My');
        sensorsClick({
          button_name: 'vip_dialog_my_limit_btn'
        });
      }
    };
    const {
      loan: loanPrecision,
      pledge: pledgePrecision,
      interest: interestPrecision
    } = usePrecision();
    return {
      t,
      ...toRefs(state),
      ...methods,
      toVipProgram,
      // checkUser,
      userInfo,
      accounts,
      // isUFA,
      times,
      toFormat,
      formatLocalTime,
      // maxNum,
      loanPrecision,
      pledgePrecision,
      interestPrecision,
      isVIP,
      isSub
      // loanEnabledTokens: props.data,
    };
  }
};